import { createServerFn } from "@tanstack/react-start";

export const FOUNDING_PLACES = 49;

// Public, unauthenticated: returns only a count, never any user data.
export const getFoundingPlaces = createServerFn({ method: "GET" }).handler(
  async () => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { count, error } = await supabaseAdmin
      .from("profiles")
      .select("id", { count: "exact", head: true });
    if (error) {
      console.error("getFoundingPlaces count failed:", error.message);
      return { claimed: 0, total: FOUNDING_PLACES };
    }
    return {
      claimed: Math.min(count ?? 0, FOUNDING_PLACES),
      total: FOUNDING_PLACES,
    };
  },
);
